// MF-554 — The small chips of a Library item: kind, Beta (still being validated) and "no data".
import { Chip, Tooltip } from '@mui/material'

const sx = { height: 18, fontSize: 10 }

const ItemChips = ({ item, showKind = true }) => (
  <>
    {showKind ? <Chip size='small' label={item.kind === 'card' ? 'Card' : 'Chart'} sx={sx} /> : null}
    {item.status === 'beta' ? (
      <Tooltip title='Beta: still being validated. Beta items are only offered where they are switched on (Maestro).'>
        <Chip size='small' variant='outlined' label='Beta' sx={{ ...sx, color: 'text.secondary' }} />
      </Tooltip>
    ) : null}
    {!item.compatible ? (
      <Tooltip title={item.reason || 'No data for this school'}>
        <Chip size='small' variant='outlined' color='warning' label='No data' sx={sx} />
      </Tooltip>
    ) : null}
  </>
)

export default ItemChips
